/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type {
  GetWithdrawalSecrets200,
  GetWithdrawalSecrets400,
  GetWithdrawalSecrets403,
  GetWithdrawalSecretsQueryResponse,
} from '../entities/GetWithdrawalSecrets'
import type { ToZod } from '@kubb/plugin-zod/utils'
import { errorStructSchema } from './errorStructSchema'
import { v1GetTaxoparkWithdrawalSecretsResponseSchema } from './v1/getTaxoparkWithdrawalSecretsResponseSchema'
import { z } from 'zod'

/**
 * @description OK
 */
export const getWithdrawalSecrets200Schema = z.lazy(() => v1GetTaxoparkWithdrawalSecretsResponseSchema) as unknown as ToZod<GetWithdrawalSecrets200>

/**
 * @description Bad Request
 */
export const getWithdrawalSecrets400Schema = z.lazy(() => errorStructSchema) as unknown as ToZod<GetWithdrawalSecrets400>

/**
 * @description Forbidden
 */
export const getWithdrawalSecrets403Schema = z.any() as unknown as ToZod<GetWithdrawalSecrets403>

export const getWithdrawalSecretsQueryResponseSchema = z.lazy(() => getWithdrawalSecrets200Schema) as unknown as ToZod<GetWithdrawalSecretsQueryResponse>